import src from "IMAGE";
export default { src, width: 417, height: 550, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
